import styles from './styles.module.scss';
import React, { FunctionComponent, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Table from '../../../../components/Table';
import { getColumns, getData, INotificationData } from './utils';
import { updateProfileRoutine } from '../../routines';
import { IAppState } from '../../../../common/models/store/IAppState';
import { User } from '../../../../common/models/user/User';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { INotifications } from '../../../../common/models/user/INotifications';
import { AutoSendReport } from '../../../../common/enums/AutoSendReport';
import { IRowAccessor } from '../../../../common/models/table/IRowAccessor';

interface IProps {
  user: User;
  isSaving: boolean;
  updateProfile: IBindingCallback1<{ notifications: INotifications }>;
}

const NotificationsPane: FunctionComponent<IProps> = ({ user, isSaving, updateProfile }) => {
  const onCellClick = (
    { accessor }: IRowAccessor<INotificationData>,
    event: MouseEvent<HTMLElement>
  ) => {
    switch (accessor) {
      case 'value':
      case 'frequency':
        event.stopPropagation();
        break;
      default:
        break;
    }
  };

  const onUpdateProfile = (field: keyof INotifications, val: boolean) => {
    let value: boolean | null | AutoSendReport = val;

    if (field === 'autoSendReport') {
      value = val ? AutoSendReport.EachReferenceComplete : null;
    }

    updateProfile({ notifications: { ...user.settings.notifications, [field]: value } });
  };

  const onUpdateReferenceCheck = (val: AutoSendReport) => updateProfile({
    notifications: { ...user.settings.notifications, autoSendReport: val }
  });

  return (
    <div className={styles.notificationPane}>
      <div className="settingsTitle ml-3 mb-5">
        <FormattedMessage id="notificationsPane.title" defaultMessage="Email notification preferences" />
      </div>
      <Table
        config={{
          columns: getColumns(onUpdateProfile, onUpdateReferenceCheck),
          data: { items: getData(user.settings.notifications), total: 3 },
          onCellClicked: onCellClick,
          loading: isSaving
        }}
      />
    </div>
  );
};

const mapStateToProps = ({
  user: { user },
  settings: { profile: { isSaving } }
}: IAppState) => ({ user: user as User, isSaving });

const mapDispachToProps = {
  updateProfile: updateProfileRoutine
};

export default connect(mapStateToProps, mapDispachToProps)(NotificationsPane);
